// Vuex records module mutations types
export const FILL_PROJECT_DETAILS = 'FILL_PROJECT_DETAILS';
